module.exports = __webpack_public_path__ + "static/frybread-18ed69926bf379345e4eccec61eb8e75.jpg";